// Tracking number patterns for carrier detection
// UPS: Starts with 1Z, 1Y, 1A, or 1B, followed by 16 alphanumerics (total 18 characters)
const UPS_PATTERN = /^1[YZAB][0-9A-Z]{16}$/i;

// FedEx: 12, 15, 20, 22 digits (not starting with 9 to avoid USPS)
// Note: FedEx SmartPost overlaps with USPS. Consider checking USPS after FedEx.
const FEDEX_PATTERN = /^(?!9)(?:[0-9]{12}|[0-9]{15}|[0-9]{20}|[0-9]{22})$/;

// USPS: 13-char (2 letters + 9 digits + "US"), or 16, 20, 22, 26-digit numbers, or 12-/21-digit starting with 9
const USPS_PATTERN =
  /^9[0-9]{11}$|^9[0-9]{21}$|^[0-9]{16}$|^[0-9]{20}$|^[0-9]{22}$|^[0-9]{26}$|^[A-Z]{2}[0-9]{9}US$/i;

// DHL: 10, 12, 14 digit numbers, or 10 alphanumeric chars
const DHL_PATTERN = /^[0-9]{10}$|^[0-9]{12}$|^[0-9]{14}$|^[0-9A-Z]{10}$/i;

function trackingUrl(trackingNumber) {
  if (trackingNumber === null || trackingNumber === undefined) {
    return '';
  }

  const cleanTrackingNumber = trackingNumber.replace(/\s/g, '');

  return detectCarrierByTrackingNumber(cleanTrackingNumber);
}

function detectCarrierByTrackingNumber(trackingNumber) {
  // UPS tracking numbers: Starts with 1Z, 1Y, 1A, or 1B, then 16 alphanumerics
  if (UPS_PATTERN.test(trackingNumber)) {
    return `https://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=${trackingNumber}`;
  }

  // USPS tracking numbers: Starts with 9, ends with US, or specific digit lengths
  if (USPS_PATTERN.test(trackingNumber)) {
    return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${trackingNumber}`;
  }

  // FedEx tracking numbers: 12, 15, 20, 22 digits (not starting with 9)
  if (FEDEX_PATTERN.test(trackingNumber)) {
    return `https://www.fedex.com/apps/fedextrack/?tracknumbers=${trackingNumber}`;
  }

  // DHL tracking numbers: 10, 12, 14 digits, or 10 alphanumeric chars
  if (DHL_PATTERN.test(trackingNumber)) {
    return `https://www.dhl.com/en/express/tracking.html?AWB=${trackingNumber}`;
  }

  // If no pattern matches, return empty string
  return '';
}

export default trackingUrl;
